export type PlanQuantity = {
  itemKey: string;
  quantity: number;
};

export type PlanSelectAction =
  | { type: 'subscribe' }
  | { type: 'blocked-incomplete' }
  | {
      type: 'change-plan';
      subscriptionId: string;
      planCode: string;
      priceId: string;
      quantities: PlanQuantity[];
      interval?: string;
    };

type ResolvePlanSelectActionInput = {
  isFreePlan?: boolean;
  planCode: string;
  selectedPrice: { priceId: string; interval: string } | null;
  quantityItems: { itemKey: string; defaultQuantity: number }[];
  subscriptionDetails: { subscriptionId: string; status?: string } | null;
};

export const isIncompleteCheckout = (status?: string) => status?.toLowerCase() === 'incomplete';

const buildQuantities = (
  quantityItems: ResolvePlanSelectActionInput['quantityItems']
): PlanQuantity[] =>
  quantityItems.map((item) => ({
    itemKey: item.itemKey,
    quantity: item.defaultQuantity,
  }));

export const resolvePlanSelectAction = ({
  planCode,
  selectedPrice,
  quantityItems,
  subscriptionDetails,
}: ResolvePlanSelectActionInput): PlanSelectAction => {
  const subscriptionId = subscriptionDetails?.subscriptionId;
  if (subscriptionId) {
    if (isIncompleteCheckout(subscriptionDetails?.status)) {
      return { type: 'blocked-incomplete' };
    }

    return {
      type: 'change-plan',
      subscriptionId,
      planCode,
      priceId: selectedPrice?.priceId ?? '',
      quantities: buildQuantities(quantityItems),
      interval: selectedPrice?.interval,
    };
  }

  return { type: 'subscribe' };
};
